import React from "react";
import {
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTagList,
  TimelineTagPill,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const PropertySaved = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">updated by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">Mortgage info included:</span>
        <span className="timeline-meta-value">{milestone.details}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    {milestone.newMortgageTags.length > 0 &&
      <TimelineSection>
        <TimelineSectionTitle>
          {milestone.newMortgageTags.length > 1 ? "Tags Assigned" : "New Mortgage Tag"}
        </TimelineSectionTitle>
        <TimelineTagList>
          {milestone.newMortgageTags.map((mortgageTag) => (
            <TimelineTagPill key={mortgageTag.label}>
              <strong>{mortgageTag.label}</strong>
              {(mortgageTag.label === 'Loan Type' || mortgageTag.label === 'Property Type') &&
                <span>- {mortgageTag.discrepancyFields}</span>
              }
            </TimelineTagPill>
          ))}
        </TimelineTagList>
      </TimelineSection>
    }
  </TimelineContent>
)

export default PropertySaved
